import getMeta from './get_meta';

/**
 * Gets the locale from meta tag if exists
 */
export default function getLocale(_form) {
  return getMeta('locale');
}
